import { createSlice } from "@reduxjs/toolkit";
import { fetchPaymentHistory } from "../thunks/paymentHistoryThunk";
import { getUnitPaymentDetails } from "../thunks/paymentThunks";

const initialState = {
  historyData: [],
  metrics: {},
  isLoading: false,
  error: null,
  unitPaymentDetails: {
    info: null,        
    payments: [],     
    loading: false,
    error: null,
  },
};

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentHistory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPaymentHistory.fulfilled, (state, action) => {
        const raw = action.payload?.data || {};
        const records = Array.isArray(raw.data) ? raw.data : [];

        state.isLoading = false;
        state.historyData = records;
        state.metrics = raw.metrics || {};
      })
      .addCase(fetchPaymentHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Something went wrong";
      });

    // NEW: unit payment details
    builder
      .addCase(getUnitPaymentDetails.pending, (state) => {
        state.unitPaymentDetails.loading = true;
        state.unitPaymentDetails.error = null;
      })
      .addCase(getUnitPaymentDetails.fulfilled, (state, action) => {
        state.unitPaymentDetails.loading = false;
        const payload = action.payload?.data || {};
        state.unitPaymentDetails.info = payload.tenantInfoCards || null;
        state.unitPaymentDetails.payments = Array.isArray(payload.payments) ? payload.payments : [];
      })
      .addCase(getUnitPaymentDetails.rejected, (state, action) => {
        state.unitPaymentDetails.loading = false;
        state.unitPaymentDetails.error = action.payload || "Failed to load unit payments";
      });
  },
});

export default paymentSlice.reducer;
